var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"home-banner"},[_c('div',{staticClass:"go-search",on:{"click":function($event){return _vm.goSearch()}}},[_vm._v("问问DeepSeek+小智")])])}
var staticRenderFns = []

export { render, staticRenderFns }